import React, { HTMLAttributes } from 'react';
import classnames from 'classnames';
import { gikClassPrefix } from '@gik/core/constants';
import { IconSize } from '../types';

export interface FontIconProps extends HTMLAttributes<HTMLElement> {
  name: string;
  size?: IconSize;
  ligatures?: boolean;
}

const blockName = `${gikClassPrefix}-fonticon`;

export default function FontIcon({
  name,
  size,
  className,
  ligatures,
  ...otherProps
}: FontIconProps): React.ReactElement {
  const notFoundStr = '⛔';

  const mapping: { [key: string]: string } = FontIcon['iconMap'];

  if (!mapping) {
    return (
      <i className={blockName} title={'FontIcon has no mapping'}>
        {notFoundStr}
      </i>
    );
  }
  const iconClass: string = mapping[name];

  const classes = classnames([
    blockName,
    { [`${blockName}--size-${size}`]: size },
    { [`${blockName}--notfound`]: !iconClass },
    iconClass,
    className || '',
  ]);

  if (!name)
    return (
      <i className={classes} title={'name is missing'}>
        {notFoundStr}
      </i>
    );
  if (!iconClass)
    return (
      <i className={classes} title={`can't find mapping for ${name}`}>
        {notFoundStr}
      </i>
    );

  let children = null;
  if (ligatures) children = iconClass;
  return (
    <i className={classes} {...otherProps}>
      {children}
    </i>
  );
}
